module.exports = __webpack_public_path__ + "img/graph-line-black.d9c5f095.svg";